
import Vue from "vue";
import BankBalance from "@/models/base/bank-balance";
import { BankService } from "@/services/bank-service";
import { printHumanFloat } from "@/utils/pretty-print";
import { BankType } from "@/models/base";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	filters: {
		printHumanFloat
	},
	data() {
		return {
			balances: [] as BankBalance[],
			bankTypes: [] as BankType[],
		};
	},
	computed: {
		hasModule(): boolean {
			return AuthService.hasModule(this.requiredModuleId);
		},
		requiredModuleId(): number {
			return MODULE.BANKGEGEVENS_VERWERKEN;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		}
	},
	async created() {
		this.bankTypes = await BankService.getTypes();
		this.balances = await BankService.getAllBalances();
		this.balances.map((b) => {
			b.Name = this.bankTypes.filter(t => t.ID == b.TypeID)[0].Name;
			return b;
		});
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
